__turbopack_context__.v({
  "article": "VcCEwG_article",
  "container": "VcCEwG_container",
  "navCard": "VcCEwG_navCard",
  "navCardNext": "VcCEwG_navCardNext",
  "navLabel": "VcCEwG_navLabel",
  "navSectionTitle": "VcCEwG_navSectionTitle",
  "navSpacer": "VcCEwG_navSpacer",
  "navTitleRow": "VcCEwG_navTitleRow",
  "navigation": "VcCEwG_navigation",
  "title": "VcCEwG_title",
});
